// extracted by mini-css-extract-plugin
module.exports = {"links":"_5b8c22739105724bf9dab86d615beedb"};